var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M27.286 0H2.714A2.714 2.714 0 000 2.714v24.572A2.714 2.714 0 002.714 30h24.572A2.714 2.714 0 0030 27.286V2.714A2.714 2.714 0 0027.286 0zM9.283 25.904a.79.79 0 01-.79.79H5.133a.79.79 0 01-.79-.79V11.812a.79.79 0 01.79-.79h3.362a.79.79 0 01.79.79v14.092zm-2.47-16.21a3.194 3.194 0 110-6.388 3.194 3.194 0 010 6.388zm20.039 16.274a.726.726 0 01-.727.726h-3.607a.726.726 0 01-.726-.726v-6.61c0-.987.29-4.321-2.577-4.321-2.223 0-2.674 2.282-2.765 3.307v7.624a.726.726 0 01-.726.726h-3.489a.726.726 0 01-.726-.726v-14.22c0-.4.325-.726.726-.726h3.49c.4 0 .725.325.725.726v1.23c.825-1.238 2.05-2.192 4.658-2.192 5.777 0 5.744 5.396 5.744 8.361v6.82z"
  })));
}

export default SvgLinkedinicon;